import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    person: {
      birthdate: null,
      professional_status: null,
      liberal_profession: null,
      has_digital_devices: null,
      civil_status: null,
      number_of_children: null,
      has_pet: null,
      house_owner: null,
      own_primary_house: null,
      own_secondary_house: null,
      own_apartment_building: null,
      foreseen_house_work: null,
      has_mortgage: null,
      vehicle_owner: null,
      often_traveling_abroad: null,
      often_doing_sport: null,
      salary_category: null
    },
    belongings: {
    // DATA EXAMPLE
      // family: {
      //   rc: 'own',
      //   pj: 'own',
      //   pet: 'unknown'
      // },
    }
  // RETURN DATA EXAMPLE
    // belongings: [
    //   {
    //     "risk_object": "house",
    //     "covers": ["rc", ...],
    //     "unknown": ["hello", ...]
    //   }
    // ]
  },
  getters: {
    loading (state) {
      return state.loading
    },
    getAge (state) {
      return moment().diff(state.person.birthdate, 'years')
    },
    isIndependent (state) {
      return state.person.professional_status === 'independent'
    },
    isVehicleOwner (state) {
      const person = state.person
      return person.number_of_cars > 0 || person.number_of_vans > 0 || person.number_of_motorbikes > 0
    },
    buildCheckupData (state, getters) {
      return JSON.stringify({
        person: getters.buildPersonsData,
        belongings: getters.buildBelongingsData
      })
    },
    buildPersonsData (state, getters) {
      const person = state.person
      return {
        birthdate: moment(person.birthdate).format('DD/MM/YYYY'),
        gender: null,
        professional_status: person.professional_status,
        liberal_profession: person.liberal_profession,
        civil_status: person.civil_status,
        number_of_children: person.has_children ? 1 : 0,
        has_pet: person.has_pet,
        house_owner: person.house_owner,
        own_primary_house: person.own_primary_house,
        own_secondary_house: person.own_secondary_house,
        own_apartment_building: person.own_apartment_building,
        foreseen_house_work: person.foreseen_house_work,
        has_mortgage: person.has_mortgage,
        vehicle_owner: getters.isVehicleOwner,
        often_traveling_abroad: person.often_traveling_abroad,
        often_doing_sport: person.often_doing_sport,
        salary_category: person.salary_category,
        has_digital_devices: person.has_digital_devices
      }
    },
    buildBelongingsData (state) {
      const belongings = state.belongings
      const belongingsArray = []

      for (const riskObject in belongings) {
        const covers = []
        const unknownCovers = []

        for (const cover in belongings[riskObject]) {
          if (belongings[riskObject][cover] === 'own') covers.push(cover)
          if (belongings[riskObject][cover] === 'unknown') unknownCovers.push(cover)

          // Handling of legal car covers (RC must always be present)
          if (belongings[riskObject][cover] === 'rc') {
            covers.push('rc')
          }
          if (belongings[riskObject][cover] === 'small_omnium') {
            covers.push('small_omnium')
            covers.push('rc')
          }
          if (belongings[riskObject][cover] === 'full_omnium') {
            covers.push('full_omnium')
            covers.push('small_omnium')
            covers.push('rc')
          }
        }

        let risk = riskObject

        if (riskObject.includes('car')) risk = 'car'
        if (riskObject.includes('van')) risk = 'van'
        if (riskObject.includes('motorbike')) risk = 'motorbike'

        belongingsArray.push({risk_object: risk, covers: covers, unknown_covers: unknownCovers})
      }
      return belongingsArray
    }
  },
  mutations: {
    initializeStore (state) {
      if (localStorage.getItem('store')) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('store')))
        )
      }
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    // Update person information
    updatePersonInfo (state, payload) {
      state.person[payload.name] = payload.value
    },
    // Set Risk object value
    updateRiskRiskObject (state, payload) {
      state.belongings[payload.risk][payload.risk_object] = payload.value
    },
    parseCheckupData (state, payload, mutations) {
      this.commit('parsePersonsData', payload.person)
      this.commit('parseBelongingsData', payload.belongings)
    },
    parsePersonsData (state, payload) {
      // sets the person equal to the payload
      state.person = payload

      // changes the little differences between the interfaces
      const person = state.person
      person.birthdate = moment(payload.birthdate, 'DD/MM/YYYY').format('YYYY-MM-DD')
      person.has_children = payload.has_children > 0
      person.number_of_cars = 0
      person.number_of_vans = 0
      person.number_of_motorbikes = 0
    },
    parseBelongingsData (state, payload) {
      payload.forEach(risk => {
        this.commit('createBelonging', risk)
      })
    },
    createBelonging (state, payload) {
      const belonging = {}
      // Add the covers to the belonging
      // if belonging = vehicle => legal_insurance = the thing
      payload.covers.forEach(cover => {
        if (['car', 'van', 'motorbike'].includes(payload.risk_object)) {
          if (cover === 'full_omnium') {
            belonging.legal_insurance = 'full_omnium'
          } else if (cover === 'small_omnium') {
            belonging.legal_insurance = 'small_omnium'
          } else if (cover === 'rc') {
            belonging.legal_insurance = 'rc'
          }
        } else {
          belonging[cover] = 'own'
        }
      })

      // create the belonging
      if (payload.risk_object === 'car') {
        state.person.number_of_cars = state.person.number_of_cars + 1
        state.belongings[`${payload.risk_object}_${state.person.number_of_cars}`] = belonging
      } else if (payload.risk_object === 'van') {
        state.person.number_of_vans++
        state.belongings[`${payload.risk_object}_${state.person.number_of_vans}`] = belonging
      } else if (payload.risk_object === 'motorbike') {
        state.person.number_of_motorbikes++
        state.belongings[`${payload.risk_object}_${state.person.number_of_motorbikes}`] = belonging
      } else {
        state.belongings[payload.risk_object] = belonging
      }

      // Special fix for the digital_bag that is not passed in the person's data
      if (payload.risk_object === 'digital_bag') state.person.has_digital_devices = true
    }
  },
  actions: {
    longLoading ({commit}, payload) {
      commit('setLoading', true)
      setTimeout(() => {
        commit('setLoading', false)
      }, payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js